import React, { useEffect, useState } from "react";
import HouseKeepingRoomsUpdated from "./HouseKeepingRoomsUpdated";
import {
  handleSpringDataMutationRequest,
  handleSpringDataRequest,
} from "../../api/index";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { getAllStaffsData } from "./HouseKeepingApi";
import MockTableLoader from "../Folios/ViewManagePayments/MockLoaderTable";
import i18n from "../../modules/Auth/pages/i18n";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useSelector } from "react-redux";

function HouseKeepingGrid({ selectedLanguage }) {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage);
  }, [selectedLanguage]);

  const hotelId = useSelector((state) => state.auth.selectedHotel.hotelId);
  // const data = RoomStatus.RoomStatus;
  const [data, setData] = useState([]);

  // staff data
  const [staffData, setStaffData] = useState(["HouseKeeping Admin"]);
  const [staffVal, setStaffVal] = useState(staffData[0]);
  const [loader, setloader] = useState(false);

  // get staff list
  // useEffect(() => {
  //     handleSpringDataRequest(
  //         `core/api/v1/hk/get-all-staff`
  //     )
  //     .then((res) => res.map((item) =>
  //         setStaffData(staffData => [...staffData, item.staffName])
  //         // setStaffData(staffData => [...staffData, item.staffId.substring(0, item.staffId.indexOf('@'))])
  //         // console.log(item.staffName)
  //         // item.staffName === "" ? staffData.push("HouseKeeping Admin") : staffData.push(item.staffName)
  //     ))
  //     .catch((err) => new Error(err))
  // }, [])
  useEffect(async () => {
    setloader(true);
    await getAllData();
    setloader(false);
  }, []);

  const getAllData = async () => {
    try {
      const res = await getAllStaffsData();
      res.map((item) =>
        setStaffData((staffData) => [...staffData, item.email])
      );
    } catch (e) {
      console.error(e);
    }
  };

  // room types
  const roomTypes = ["All Rooms", "Dirty", "Clean", "Occupied", "Blocked"];
  const [roomTypeVal, setRoomTypeVal] = useState(roomTypes[0]);
  const [roomTypeInpVal, setRoomTypeInpVal] = useState("");

  // get the room data based on filters, etc.

  function getRoomIDData() {
    handleSpringDataRequest(`core/api/v1/hk/get-room-ids?forCharter=false`)
      // .then((res) => console.log(res))
      .then((res) => {
        if (roomTypeVal === "All Rooms" && staffVal === "HouseKeeping Admin") {
          setData(res);
        }
        if (roomTypeVal === "All Rooms" && staffVal !== "HouseKeeping Admin") {
          // setData(null)
          setData([]);
          res
            .filter((item) => item?.hkStaffList?.includes(staffVal) === true)
            .map((item) => setData((data) => [...data, item]));
        }
        if (roomTypeVal !== "All Rooms" && staffVal === "HouseKeeping Admin") {
          setData([]);
          res
            .filter((item) => item.roomStatus === roomTypeVal.toUpperCase())
            .map((item) => setData((data) => [...data, item]));
        }
        if (roomTypeVal !== "All Rooms" && staffVal !== "HouseKeeping Admin") {
          setData([]);
          res
            .filter(
              (item) =>
                item?.hkStaffList?.includes(staffVal) === true &&
                item.roomStatus === roomTypeVal.toUpperCase()
            )
            .map((item) => setData((data) => [...data, item]));
        }
      });
  }

  useEffect(() => {
    getRoomIDData();
  }, [roomTypeVal, staffVal]);

  function onStatusChange(event) {
    const status = event.target.value;
    const id = event.target.id;

    if (status === "CLEAN" || status === "OCCUPIED") {
      axios
        .post(
          `${process.env.REACT_APP_BG_API_URL}core/api/v1/hk/bulk-mark-rooms-dirty?${hotelId}`,
          {
            roomIds: [`${id}`],
            // "roomIds":["1"],
            staffId: "",
          }
        )
        .catch((err) => console.log("err", err.message));
      setTimeout(() => {
        event.target.checked = false;
        getRoomIDData();
      }, 1000);
    }
    if (status === "DIRTY") {
      axios
        .post(
          `${process.env.REACT_APP_BG_API_URL}core/api/v1/hk/bulk-mark-rooms-clean?${hotelId}`,
          {
            roomIds: [`${id}`],
            staffId: "",
          }
        )
        .catch((err) => console.log("err", err.message));
      setTimeout(() => {
        event.target.checked = false;
        getRoomIDData();
      }, 1000);
    }
  }

  return loader === false ? (
    <div className="houseKeepingGridWrapper">
      <div className="hkGridFilters">
        <div className="staffFilterWrapper">
          {staffData && (
            <div>
              <Autocomplete
                value={staffVal}
                onChange={(event, newValue) => {
                  setStaffVal(newValue);
                }}
                id="controllable-states-demo"
                options={staffData}
                sx={{ width: 500 }}
                renderInput={(params) => (
                  <TextField {...params} label={t("Select Staff")} />
                )}
              />
            </div>
          )}

          <div className="staffFilterNote">
            {t(
              "Select the box given in the room number to mark room status clean or dirty.The Housekeeping grid is only available for admin."
            )}
          </div>
        </div>
        <div className="roomTypeFilterWrapper">
          <div>
            <Autocomplete
              value={roomTypeVal}
              onChange={(event, newValue) => {
                setRoomTypeVal(newValue);
              }}
              inputValue={roomTypeInpVal}
              onInputChange={(event, newInputValue) => {
                setRoomTypeInpVal(newInputValue);
              }}
              id="controllable-states-demo"
              options={roomTypes}
              sx={{ width: 500 }}
              renderInput={(params) => (
                <TextField {...params} label={t("Select Room Type")} />
              )}
            />
          </div>
        </div>
      </div>

      <div className="roomsWrapper">
        {data &&
          data.map((item, index) => {
            return (
              <div key={index}>
                <HouseKeepingRoomsUpdated
                  roomNumber={item.roomId}
                  roomStatus={item.roomStatus}
                  roomCleanStatus={item.roomStatus}
                  handleStatusChange={onStatusChange}
                  selectedLanguage={selectedLanguage}
                />
              </div>
            );
          })}
      </div>
    </div>
  ) : (
    <MockTableLoader />
  );
}

export default HouseKeepingGrid;
